import React from 'react';

// One look per state across the app (styles/components.css, .status--*).
// The pages pass the status they have and the label they already show.
const VARIANT = {
  // done, in order, present
  active: 'success',
  approved: 'success',
  paid: 'success',
  present: 'success',
  completed: 'success',
  consolidated: 'success',
  // waiting for someone or something
  pending: 'warning',
  pending_payment: 'warning',
  draft: 'warning',
  late: 'warning',
  sick: 'warning',
  on_leave: 'warning',
  // stopped, refused, missing
  rejected: 'danger',
  cancelled: 'danger',
  absent: 'danger',
  expired: 'danger',
  terminated: 'danger',
  // informative
  vacation: 'info',
  leave: 'info',
  // out of use
  inactive: 'neutral',
  archived: 'neutral',
};

export const statusVariant = (status) => VARIANT[String(status || '').toLowerCase()] || 'neutral';

const StatusBadge = ({ status, variant, children, className = '' }) => (
  <span className={`status status--${variant || statusVariant(status)}${className ? ` ${className}` : ''}`}>
    {children}
  </span>
);

export default StatusBadge;
